import { useState } from "react";
import "./App.css"

function App() {
  function MainPage() {
    let currentOption = 0;
    const [text, setText] = useState("Do you love me?");
    const [buttonDisable, setButtonDisable] = useState(false)
    function onNoClick(event) {
      const { target } = event;
      currentOption = currentOption === 0 ? 1 : 0;
      target.style['transform'] = `translateX(${currentOption === 0 ? "-" : ""}25vw)`;
      // target.style[options[currentOption === 0 ? 1 : 0]] = "0%";
    }

    function onYesClick(event) {
      let yesButton = document.querySelector(".yes");
      yesButton.classList.add("btn-success");
      yesButton.classList.remove("btn-primary");
      setText("I love you too!");
      setButtonDisable(true)
    }
    return (
      <div>
      <div className="text-center troll">
        <h1>{text}</h1>
        <br />
        <button className="btn btn-primary yes" onClick={onYesClick} disabled={buttonDisable}>
          Yes
        </button>
        <br />
        <br />
        <button
          className="btn btn-primary no"
          onMouseOver={onNoClick}
          onClick={onNoClick}
          disabled={buttonDisable}
        >
          No
        </button>
      </div>
      <div className="footer text-center">
        Made by Anay. <br /> Note: This website is just for fun, and nothing here should be taken seriously.
      </div>
      </div>
    );
  }

  
  const [page] = useState(<MainPage />);
  return <div className="App">{page}</div>;
}

export default App;
